import { FunctionComponent, useRef } from 'react'
import { IconButton, Box, makeStyles, Typography } from '@material-ui/core'
import { ReactComponent as ImageUploadIcon } from 'icons/upload-image-icon.svg'
import { ReactComponent as VideoUploadIcon } from 'icons/upload-video-icon.svg'
//@ts-ignore
import { useTheme } from 'styled-components'
import styled from 'styled-components'

const StyledImageUploadIcon = styled(ImageUploadIcon)`
  && {
    width: 0.9em;
    height: 0.9em;
  }
`

const StyledVideoUploadIcon = styled(VideoUploadIcon)`
  && {
    width: 0.9em;
    height: 0.9em;
  }
`

const StyledIconButton = styled(IconButton)`
  &&{
    padding:12px
  }
`


interface AddMediaProps {
  handleChange: Function
  setPreviewImage: Function
  previewImage: string[]
  setShowMediaError: Function
  postImages: string[]
  setPostImages: Function
  getProcessedFile: Function
  videoUploaded: boolean
  maxImageFileSize: Number
  setPreviewVideo: Function
  setPostVideo: Function
  imageUploaded: boolean
  setVideoUploaded: Function
  maxVideoFileSize: Number
  setNewUploads: Function
}

export const AddMedia: FunctionComponent<AddMediaProps> = ({
  handleChange,
  previewImage,
  setPreviewImage,
  setShowMediaError,
  postImages,
  setPostImages,
  getProcessedFile,
  videoUploaded,
  maxImageFileSize,
  setPreviewVideo,
  setPostVideo,
  imageUploaded,
  setVideoUploaded,
  maxVideoFileSize,
  setNewUploads
}) => {
  const theme = useTheme()
  const handleImageUpload = (e: any) => {
    const previewImagesArray = []
    const postImagesArray = []
    const files = e.target.files

    setShowMediaError(null)
    if (files.length > 4) {
      setShowMediaError('maxNumImages')
      return false
    } else {
      Array.from(files).map((file: any) => {
        const fsMb = file.size / (1024 * 1024)
        if (fsMb > maxImageFileSize) {
          setShowMediaError('imageLimit')
          return false
        }
        if (!['jpeg', 'jpg', 'png'].includes(file?.name?.toLowerCase()?.split('.')[file?.name?.split('.').length - 1])) {
          setShowMediaError('imageType')
          return false
        }
        previewImagesArray.push(URL.createObjectURL(file))
        const fileName = file?.name?.toLowerCase()?.split('.')
        getProcessedFile(Array.of(file), ['jpeg', 'jpg', 'png'], 'stream', async ({ file }: any) => {
          postImagesArray.push({ file: file, type: fileName[fileName.length - 1] })
        })
      })
      if (previewImage.length + previewImagesArray.length > 4) {
        setShowMediaError('maxNumImages')
        return false
      }
      setPreviewImage([...previewImage, ...previewImagesArray])
      Array.prototype.push.apply(postImagesArray, postImages)
      setPostImages(postImagesArray)
      handleChange(e, 'image')
      e.target.value = ''
      setNewUploads(true)
    }
  }

  const handleVideoUpload = (e: any) => {
    const files = e.target.files
    setShowMediaError(null)
    if (files.length > 1) {
      setShowMediaError('numVideo')
      return false
    } else {
      const file = files[0]
      if (file) {
        const fsMb = file.size / (1024 * 1024)

        if (fsMb > maxVideoFileSize) {
          setShowMediaError('videoLimit')
          return false
        }
        if (!['mov', 'mp4'].includes(file?.name?.split('.')[file?.name?.split('.').length - 1]?.toLowerCase())) {
          setShowMediaError('videoType')
          setPreviewVideo([])
          setPostVideo([])
          setVideoUploaded(false)
          return false
        }
        setPreviewVideo([URL.createObjectURL(file)])
        const fileNameArray = file?.name.split('.')
        getProcessedFile(Array.of(file), ['mov', 'mp4', 'MOV'], 'stream', async ({ file }: any) => {
          setPostVideo([{ file: file, type: fileNameArray[fileNameArray.length - 1] }])
        })
        handleChange(e, 'video')
        e.target.value = ''
        setNewUploads(true)
      }
    }
  }

  const hiddenFileInputImage = useRef(null)
  const hiddenFileInputVideo = useRef(null)

  return (
    <Box display="flex">
      <StyledIconButton disabled={videoUploaded} onClick={e => hiddenFileInputImage.current.click()}>
        <input
          onChange={e => {
            handleImageUpload(e)
          }}
          type="file"
          multiple
          ref={hiddenFileInputImage}
          hidden
          accept=".jpg, .jpeg, .png, .tiff"
        />
        <StyledImageUploadIcon fill={videoUploaded ? theme.colors.accent: theme.colors.primary} />
        <Typography style={{ margin: '0 0 0 .5em' }} variant="caption">
          <Box color={theme.colors.accent1}>Image</Box>
        </Typography>
      </StyledIconButton>

      <StyledIconButton disabled={imageUploaded} onClick={e => hiddenFileInputVideo.current.click()}>
        <input
          onChange={e => handleVideoUpload(e)}
          type="file"
          multiple
          ref={hiddenFileInputVideo}
          hidden
          accept=".mov, .mp4, .mpeg"
        />
        <StyledVideoUploadIcon fill={imageUploaded ? theme.colors.accent: theme.colors.primary} />
        <Typography style={{ margin: '0 0 0 .5em' }} variant="caption">
          <Box color={theme.colors.accent1}>Video</Box>
        </Typography>
      </StyledIconButton>
    </Box>
  )
}
